export const ApiConstants = {
	3009: '3009', // Email already exists please pick a new one
	3100: '3100', // Success Register
};
